import * as yup from "yup";

export const personalInfoSchema = yup.object().shape({
  firstName: yup.string().required("First Name is required"),
  lastName: yup.string().required("Last Name is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  phoneNumber: yup.string().required("Contact No is required"),
  city: yup.string().required("City is required"),
  personalPositionCompany: yup.string().required("Job Title is required"),
  businessName: yup.string().required("Company Name is required"),
  // isEmailUpdates: yup.number().required("Email updates consent is required").oneOf([1], "Email updates consent is required"),
  // isGDPRConsent: yup.number().required("GDPR consent is required").oneOf([1], "GDPR consent is required"),
});

export const earlyStageAgeVerificationSchema = yup.object({
  dateOfBirth: yup
    .string()
    .trim()
    .required("Date of birth is required")
    .test("valid-date", "Please enter a valid date of birth", (value) =>
      Boolean(value?.trim() && parseIsoDateString(value)),
    )
    .test(
      "not-future",
      "Date of birth cannot be in the future",
      (value) => {
        if (!value?.trim()) return false;
        const parsed = parseIsoDateString(value);
        return parsed ? parsed <= endOfToday() : false;
      },
    ),
  youngProfessionalConsent: yup
    .number()
    .required("You must acknowledge approval is required")
    .oneOf(
      [1],
      "You must acknowledge approval is required before the discounted membership can be activated",
    ),
});

export type EarlyStageAgeVerificationFormValues = yup.InferType<
  typeof earlyStageAgeVerificationSchema
>;

function endOfToday(): Date {
  const d = new Date();
  d.setHours(23, 59, 59, 999);
  return d;
}

function parseDateParts(
  year: number,
  month: number,
  day: number,
): Date | null {
  if (month < 1 || month > 12 || day < 1 || day > 31) return null;

  const date = new Date(year, month - 1, day);
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null;
  }
  return date;
}

export function parseIsoDateString(value: string): Date | null {
  const trimmed = value.trim();
  if (!trimmed) return null;

  if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
    const [year, month, day] = trimmed.split("-").map(Number);
    return parseDateParts(year, month, day);
  }

  const displayMatch = trimmed.match(
    /^(\d{1,2})\s*\/\s*(\d{1,2})\s*\/\s*(\d{4})$/,
  );
  if (displayMatch) {
    const day = Number(displayMatch[1]);
    const month = Number(displayMatch[2]);
    const year = Number(displayMatch[3]);
    return parseDateParts(year, month, day);
  }

  return null;
}

export function toIsoDateInputValue(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export const membershipSchema = yup.object().shape({
  membershipName: yup.string().required("Please select a membership"),
  isAnnualMembership: yup.number().oneOf([0, 1]).required(),
});

export const termsSchema = yup.object().shape({
  isTermConditions: yup
    .number()
    .required("You must agree to the Terms and Conditions")
    .oneOf([1], "You must agree to the Terms and Conditions"),
  isDirectory: yup
    .number()
    .required("You must agree to be added to SMBF's Directory")
    .oneOf([1], "You must agree to be added to SMBF's Directory"),
});

export const checkoutSchema = yup.object().shape({
  cardNumber: yup.string().required("Card number is required"),
  expiryMonth: yup.string().required("Expiry month is required"),
  expiryYear: yup.string().required("Expiry year is required"),
  cvc: yup.string().required("CVC is required"),
  billingAddress: yup.string().required("Billing address is required"),
});
